import {
  CUSTOMER_ADD_FAILURE,
  CUSTOMER_ADD_REQUEST,
  CUSTOMER_ADD_SUCCESS,
  CUSTOMER_DELETE_FAILURE,
  CUSTOMER_DELETE_REQUEST,
  CUSTOMER_DELETE_SUCCESS,
  CUSTOMER_EDIT_FAILURE,
  CUSTOMER_EDIT_REQUEST,
  CUSTOMER_EDIT_SUCCESS,
  CUSTOMER_RESET_STATE,
  CUSTOMER_SEARCH_FAILURE,
  CUSTOMER_SEARCH_REQUEST,
  CUSTOMER_SEARCH_SUCCESS,
  CUSTOMER_VIEW_ALL_FAILURE,
  CUSTOMER_VIEW_ALL_REQUEST,
  CUSTOMER_VIEW_ALL_SUCCESS,
  CUSTOMER_VIEW_FAILURE,
  CUSTOMER_VIEW_REQUEST,
  CUSTOMER_VIEW_SUCCESS,
} from "./CustomerTypes";

// Add Customer Actions
export const customerAddRequest = (credentials) => ({
  type: CUSTOMER_ADD_REQUEST,
  payload: credentials,
});

export const customerAddSuccess = (data) => ({
  type: CUSTOMER_ADD_SUCCESS,
  payload: data,
});

export const customerAddFailure = (error) => ({
  type: CUSTOMER_ADD_FAILURE,
  payload: error,
});

// Edit Customer Actions
export const customerEditRequest = (id, updatedData) => ({
  type: CUSTOMER_EDIT_REQUEST,
  payload: { id, updatedData },
});

export const customerEditSuccess = (data) => ({
  type: CUSTOMER_EDIT_SUCCESS,
  payload: data,
});

export const customerEditFailure = (error) => ({
  type: CUSTOMER_EDIT_FAILURE,
  payload: error,
});

// View Customer Actions
export const customerViewRequest = (id) => ({
  type: CUSTOMER_VIEW_REQUEST,
  payload: id,
});

export const customerViewSuccess = (data) => ({
  type: CUSTOMER_VIEW_SUCCESS,
  payload: data,
});

export const customerViewFailure = (error) => ({
  type: CUSTOMER_VIEW_FAILURE,
  payload: error,
});

// View All Customer Actions
export const customerViewAllRequest = (payload) => ({
  type: CUSTOMER_VIEW_ALL_REQUEST,
  payload,
});

export const customerViewAllSuccess = (data) => ({
  type: CUSTOMER_VIEW_ALL_SUCCESS,
  payload: data,
});

export const customerViewAllFailure = (error) => ({
  type: CUSTOMER_VIEW_ALL_FAILURE,
  payload: error,
});

// View All Search Customer Actions
export const customerSearchViewAllRequest = () => ({
  type: CUSTOMER_SEARCH_REQUEST,
});

export const customerSearchViewAllSuccess = (products) => ({
  type: CUSTOMER_SEARCH_SUCCESS,
  payload: products,
});

export const customerSearchViewAllFailure = (error) => ({
  type: CUSTOMER_SEARCH_FAILURE,
  payload: error,
});

// Delete Customer Actions
export const customerDeleteRequest = (id) => ({
  type: CUSTOMER_DELETE_REQUEST,
  payload: id,
});

export const customerDeleteSuccess = (data) => ({
  type: CUSTOMER_DELETE_SUCCESS,
  payload: data,
});

export const customerDeleteFailure = (error) => ({
  type: CUSTOMER_DELETE_FAILURE,
  payload: error,
});

// Reset State Action
export const customerResetState = () => ({
  type: CUSTOMER_RESET_STATE,
});
